<template>
  <div style="width: 40%;height: 100px;text-align: center;" :style="{
      '--radio-button-color': $store.getters.getRadioButtonColor,
      '--star-svg-height': `${starHeight}px`
      }">
    <ul class="rating-card__list">
      <li class="rating-card__list__item" v-bind:class="{'-select': model.crowded}"
          v-for="(model, index) in question.answers"
          v-on:click="selectStar(model, index)" v-bind:key="index">
        <label>
          <svg v-bind:class="{'bounce': model.bounced}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
               viewBox="0 0 576 512" style="enable-background:new 0 0 576 512;" xml:space="preserve" class="star-ico">
<g id="Слой_1">
</g>
            <g id="Слой_2">
	<g>
		<g>
			<path d="M286.9,284c7.3-12.8,12-26.8,17-41.7c5.2-15.4,10.6-31.4,19.1-46.1c11.2-19.3,27.8-35.3,47.2-46.5V28.4
				c0-15.3-12.4-27.7-27.7-27.7h-111c-15.3,0-27.7,12.4-27.7,27.7v144.5H59.2c-15.3,0-27.7,12.4-27.7,27.7v111
				c0,15.3,12.4,27.7,27.7,27.7h143.4C237.2,335.3,269.6,314.3,286.9,284z"/>
      <path d="M514.8,172.9H370.5c-12.3,8.8-22.8,20.1-30.4,33.2c-7.6,13-12.4,27.3-17.5,42.5c-5.1,15.1-10.4,30.7-18.6,45.1
				c-20.5,36-59.1,60.8-100.3,65.3v124.8c0,15.3,12.4,27.7,27.7,27.7h111c15.3,0,27.7-12.4,27.7-27.7V339.4h144.5
				c15.3,0,27.7-12.4,27.7-27.7v-111C542.5,185.4,530.1,172.9,514.8,172.9z"/>
		</g>
	</g>
</g>
</svg>



          <div style="font-weight:bold">{{ model.title }}&nbsp;&nbsp;</div>
        </label>
      </li>
    </ul>


    <label v-for="model in question.answers" v-bind:key="model.uid">
      <input style="display:none;" type="radio"
             v-bind:id="'star'+ model.uid"
             v-on:click="setRadio(model.uid)"
             :value="model.uid"
             :name="question.uid"
             :checked="model.selected"
      />
    </label>

    <transition name="fade">
      <comment v-show="showComment" :placeholder="commentPlaceholder" :name="commentName"></comment>
    </transition>
    <input type="hidden" class="answerSelected" data-question="question.uid" v-model="answerSelected">
  </div>
</template>

<script>
import Vue from 'vue';
import Comment from './Comment';
import Star from 'vue-rate-it/glyphs/star';


export default {
  name: 'plus',
  props: ['question'],
  data() {
    return {
      answerSelected: false,
      showComment: false,
      commentPlaceholder: false,
      commentName: false,
      radioButtonCheckedPath: false,
      radioButtonUncheckedPath: false,
      thumbsUp: '',
      starHeight: 30,
      stars: [{
        value: 1,
        text: '',
        gradientFrom: '#FC8885',
        gradientTo: '#FB7C7F',
        selected: false,
      },
        {
          value: 2,
          text: '',
          gradientFrom: '#FB7A7E',
          gradientTo: '#F96A74',
          selected: false,
        },
        {
          value: 4,
          text: '',
          gradientFrom: '#F8636F',
          gradientTo: '#F75062',
          selected: false,
        },
        {
          value: 5,
          text: '',
          gradientFrom: '#F75165',
          gradientTo: '#F6415A',
          selected: false,
        }
      ]
    }
  },
  created() {
    // register the icon
    this.star = Star
  },
  mounted() {
    this.radioButtonCheckedPath = this.$store.getters.getRadioButtonCheckedPath;
    this.radioButtonUncheckedPath = this.$store.getters.getRadioButtonUnCheckedPath;
  },
  methods: {
    setRadio: function (uid) {
      this.showComment = false;
      this.commentPlaceholder = false;
      this.commentName = false;

      this.$emit("inputClick", uid);

      this.question.answers.forEach((item, index) => {
        if (item.uid === uid) {
          item.selected = true;
          if (item.is_allow_comment) {
            this.showComment = true;
            this.commentPlaceholder = item.comment_placeholder;
            this.commentName = 'comment_' + this.question.uid;
          }
          Vue.set(this.question.answers, index, item);
        } else {
          item.selected = false;
          Vue.set(this.question.answers, index, item);
        }

        this.$emit("checkDependency", uid);
      });
    },
    onRatingSelected(e) {
      this.setRadio(e);
    },
    resetStars() {
      this.question.answers.forEach(model => model.crowded = false)
    },
    selectStar(model, index) {
      this.resetStars()
      this.setRadio(model.uid);
      setTimeout(() => {
        this.question.answers[index].crowded = true;
        model.bounced = true;
      }, 100)
    },
  },
  components: {
    Comment
  }
}
</script>

<style>

:root {
  --star-svg-height: '100px'
}

@keyframes bounce {
  0% {
    width: 32px;
    height: 56px;
  }
  25% {
    width: 34px;
    height: 58px;
  }
  50% {
    width: 36px;
    height: 59px;
  }
  100% {
    width: 38px;
    height: 60px;
  }
}

.bounce {
  animation-name: bounce;
  animation-duration: 0.2s;
}
</style>
<style lang="scss">
.rating-card__list {
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  flex-basis: auto;

  &__item {
    flex-basis: 25%;
    flex-grow: 1;
    font-size: 12px;
    padding-left: 10px;

    .-checked & {
      font-weight: 200;
    }

    input {
      display: none;
    }

    input:checked + label {
      font-weight: 500;
    }

    svg {
      width: var(--star-svg-height);
      height: 54px;

      &:hover {
        cursor: pointer;
      }

      path {
        fill: #e6e7ea;
      }
    }

    &.-select {
      svg {
        path {
          fill: var(--radio-button-color)
        }
      }
    }
  }
}
</style>
